import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, Checkbox, FormControlLabel, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import { useForm } from "../../../../hooks/useForm";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { FormCosegurosExternosPracticas } from "./FormCosegurosExternosPracticas";
import ModalAbm from "../../../compartidos/abms/ModalAbm";
import { FormVerCosegurosExternosPracticas } from "./FormVerCosegurosExternosPracticas";
import { nuevaPracticaCoseguro } from "../../../../actions/contrataciones/configuraciones/ambCosegurosExternosActions";


const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});

export const FormIngresoCoseguroExterno = (props) => {

    const classes = useStyles();
    const { formData, permisoEdit, permisoAlta, editando, idObraSocial } = props;
    const { permisos: permisosUser } =  useSelector(state => state.auth);
    const dispatch = useDispatch();

    const [openModalAltaPractica, setOpenModalAltaPractica] = useState(false);

    const [openModalVerPractica, setOpenModalVerPractica] = useState(false);
    

    const formInit = {
        descripcion: ""
    }

    const handleChangeCheckbox = (e) => {
        setearValor(e.target.name, e.target.checked);
      };
  
    const [formValues, handleInputChange, , setearValor] = useForm(formData ? formData : formInit);
      
    const handleSave = (e) => {
        e.preventDefault()
        props.handleSave(formValues);
    };

    const handleSavePractica = (data) => {
        dispatch(nuevaPracticaCoseguro(idObraSocial, data.Grupo, data.idsPracticas, data.pideAutorizacion, setOpenModalAltaPractica));
      };
  
  return (
    <ValidatorForm onSubmit={handleSave}>
    <Grid container style={{ padding: 25 }}>
      <Grid item xs={12} md={6}>
        <TextValidator
          margin="normal"
          label="Descripcion grupo"
          name="descripcion"
          value={formValues.descripcion}
          autoComplete="off"
          onChange={handleInputChange}
          fullWidth
          style={{ paddingRight: "0.5rem" }}
          validators={["required"]}
          errorMessages={["La descripción es requerida"]}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <TextValidator
          margin="normal"
          label="Tope"
          name="tope"
          value={formValues.tope}
          autoComplete="off"
          onChange={handleInputChange}
          fullWidth
          style={{ paddingRight: "0.5rem" }}
          validators={["required", "matchRegexp:^[0-9]+$"]}
          errorMessages={[
            "El tope es requerido",
            "Solo se permiten números positivos enteros",
          ]}
        />
      </Grid>

      <Grid item xs={6} md={3}>
        <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
          <KeyboardDatePicker
            margin="normal"
            id="fechaDesde"
            label="Fecha desde"
            format="dd/MM/yyyy"
            okLabel="Aceptar"
            required={true}
            name="fechaDesde"
            maxDate={new Date(3001, 11, 30)} //maxDate
            minDate={moment().subtract("year", 200)}
            clearLabel="Limpiar"
            cancelLabel="Cancelar"
            value={
              moment(formValues.fechaDesde).isValid()
                ? moment(formValues.fechaDesde)
                : null
            }
            onChange={(date) => {
              setearValor("fechaDesde", date);
            }}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
          />
        </MuiPickersUtilsProvider>
      </Grid>

      <Typography variant="h6" component="h2">
          Coseguros CMP
      </Typography>

      <Grid item xs={6} md={3}>
        <TextValidator
          margin="normal"
          label="Valor"
          name="valor"
          value={formValues.valor}
          autoComplete="off"
          onChange={handleInputChange}
          fullWidth
          style={{ paddingRight: "0.5rem", marginLeft: -145, marginTop: 25 }}
          validators={["required", "isPositive"]}
          errorMessages={[
           "El valor es requerido",
            "Solo se permiten números",
          ]}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <TextValidator
          margin="normal"
          label="Valor excede"
          name="valorExcede"
          value={formValues.valorExcede}
          autoComplete="off"
          onChange={handleInputChange}
          fullWidth
          style={{ paddingRight: "0.5rem", marginLeft: -145, marginTop: 25 }}
          validators={["required", "isPositive"]}
          errorMessages={[
           "El valor excede es requerido",
            "Solo se permiten números",
          ]}
        />
      </Grid>

      <Grid container item xs={6} md={3} justify="center">
        <Grid item container justify="left">
          <FormControlLabel
            control={
              <Checkbox
                name="defaultCantidad"
                //aria-describedby={defaultCantidad}
                checked={formValues.defaultCantidad}
                onChange={handleChangeCheckbox}
              />
            }
            label="Marca en asistencia"
          />
          
          <FormControlLabel
            control={
              <Checkbox
                name="saltaPago"
                //aria-describedby={defaultCantidad}
                checked={formValues.saltaPago}
                onChange={handleChangeCheckbox}
              />
            }
            label="Salta pago"
          />
        </Grid>
      </Grid>

      {/* <Typography variant="h6" component="h2">
          Coseguros Externos
      </Typography>

      <Grid item xs={6} md={3}>
        <TextValidator
          margin="normal"
          label="Valor"
          name="valores.valorExterno"
          value={formValues.valores?.valorExterno}
          autoComplete="off"
          onChange={handleInputChange}
          fullWidth
          style={{ paddingRight: "0.5rem", marginLeft: -180, marginTop: 25 }}
          validators={["isPositive"]}
          errorMessages={[
            "Solo se permiten números",
          ]}
        />
      </Grid>
      <Grid item xs={6} md={3}>
        <TextValidator
          margin="normal"
          label="Valor excede"
          name="valores.valorExcedeExterno"
          value={formValues.valores?.valorExcedeExterno}
          autoComplete="off"
          onChange={handleInputChange}
          fullWidth
          style={{ paddingRight: "0.5rem", marginLeft: -180, marginTop: 25 }}
          validators={["isPositive"]}
          errorMessages={[
            "Solo se permiten números",
          ]}
        />
      </Grid> */}


      <Grid container className={classes.botonera}>
        <Grid item xs={12}>
          <Grid
            container
            spacing={1}
            direction="row"
            justify="flex-end"
            alignItems="center"
          >    
            <Grid item xs={6}>            
          {
            (editando) && (
              <ModalAbm title="Agregar Practicas" open={openModalAltaPractica} setOpen={setOpenModalAltaPractica}>
                <FormCosegurosExternosPracticas Grupo={formValues.idOSGrupo} idObraSocial={idObraSocial} handleSavePractica={handleSavePractica} handleCloseModal={() => setOpenModalAltaPractica(false)}/>
              </ModalAbm>
              )}
              { (editando) && (
              <Button variant="contained" color="primary" onClick={() => setOpenModalAltaPractica(true)} style={{ float: "left", marginTop: "0.0rem", marginLeft: "-4rem"}}>+ Agregar Prácticas</Button>
            )}
                        
          { 
            (editando) && (
              <ModalAbm title="Ver Practicas" open={openModalVerPractica} setOpen={setOpenModalVerPractica}>
                <FormVerCosegurosExternosPracticas Grupo={formValues.idOSGrupo} idObraSocial={idObraSocial} handleSavePractica={handleSavePractica} handleCloseModal={() => setOpenModalVerPractica(false)}/>
              </ModalAbm>
              )}
              { (editando) && (
              <Button variant="contained" color="primary" onClick={() => setOpenModalVerPractica(true)} style={{ float: "left", marginTop: "0.0rem", marginLeft: "1rem" }}>Ver Prácticas</Button>
              ) }

            </Grid>
            
            {
            (editando) && (
            <FormControlLabel
              control={
                <Checkbox
                  name="nuevoPeriodo"
                  //aria-describedby={defaultCantidad}
                  checked={formValues.nuevoPeriodo}
                  onChange={handleChangeCheckbox}
                />
              }
              label="Nuevo Período"
            />
            ) }
            <Button
              variant="contained"
              color="secondary"
              size="small"
              startIcon={<CancelIcon />}
              onClick={props.cerrarModal}
            >
              CANCELAR
            </Button>
            {(validarSoloUnPermiso(permisosUser, permisoAlta) ||
              validarSoloUnPermiso(permisosUser, permisoEdit)) && (
              <Button
                variant="contained"
                color="primary"
                size="small"
                startIcon={<SaveIcon />}
                type="submit"
                style={{ marginLeft: "0.5rem" }}
              >
                GUARDAR
              </Button>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </ValidatorForm>
  )
}